import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  HEADER_FILL,
  TABLE_HEADER_FILL,
  formatNumber,
  formatPercent,
  mergeRow,
  safeText,
  setCell,
} from "./principle6SheetHelpers";
import { filterPopulatedRows, setStandardDetailWidths } from "./principle8SheetHelpers";

const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

export const SHEET_NAME = "Details of CSR Project";

const SHEET_TITLE = "Details of beneficiaries of CSR Projects";

export function buildDetailsOfCSRProjectSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });
  setStandardDetailWidths(ws, { D: 8, E: 24, F: 22, G: 24 });

  const rows = filterPopulatedRows(
    sectionC?.principle8?.leadershipIndicator?.beneficiariesOfCSRProjects,
    ["csrProjectName", "numberOfBeneficiaries", "percentageFromVulnerableMarginalizedGroups"]
  );

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_8, { mergeEnd: COL_G });

  mergeRow(ws, TITLE_ROW, COL_D, COL_G, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr.No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "CSR Project", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_F, "No. of persons benefitted from CSR Projects", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(
    ws,
    HEADER_ROW,
    COL_G,
    "% of beneficiaries from vulnerable and marginalized groups",
    { bold: true, fill: TABLE_HEADER_FILL, align: "center" }
  );

  rows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, safeText(item?.csrProjectName), { align: "left" });
    setCell(ws, row, COL_F, formatNumber(item?.numberOfBeneficiaries), { align: "center" });
    setCell(
      ws,
      row,
      COL_G,
      formatPercent(item?.percentageFromVulnerableMarginalizedGroups),
      { align: "center" }
    );
  });

  return ws;
}
